export default __webpack_public_path__ + "static/media/rocket.21c06f38.svg";